import { render, staticRenderFns } from "./transaction.layout.vue?vue&type=template&id=3976d104"
import script from "./transaction.layout.vue?vue&type=script&lang=js"
export * from "./transaction.layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports